const NS = 'SiteMenuWidget';
const CLS = 'siteMenuWidget';

export class SiteMenuWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$buttonLogout = this.$element.find(`.${CLS}-menu-link--logout`);
		this.logoutAPI = this.$buttonLogout.data('logoutApi');
		this.requestVerificationToken = this.$buttonLogout.data('requestVerificationToken');
		this.dataRedirectURL = this.$buttonLogout.data('redirectUrl');
		this.reportApi = this.$element.data('reportApi');

		this.logoutClickEvent();
		this.loadReportsCount();
	}

	logoutClickEvent() {
		this.$buttonLogout.on('click', (event) => {
			event.preventDefault();
			event.stopPropagation();

			let request = new Request(this.logoutAPI, {
				method: 'POST',
				headers: {
					'X-Requested-With': 'XMLHttpRequest',
					'X-XSRF-Token': this.requestVerificationToken
				}
			});

			// submit form data using fetch api
			fetch(request).then((response) => {
				if(response.status === 200) {
					window.location = this.dataRedirectURL;
				}
			});
		});
	}

	loadReportsCount() {
		let setSiteMenuLinkCountWidgetValue = (response, key) => {
			let value = response[key];
			if(!_.isNil(value)) {
				let $siteMenuLinkCountWidget = this.$element.find(`.siteMenuLinkCountWidget[data-report-key=${key}]`);
				if($siteMenuLinkCountWidget && $siteMenuLinkCountWidget.length > 0) {
					if(value > 0) {
						$siteMenuLinkCountWidget.html(value);
						$siteMenuLinkCountWidget.show();
					}
					else {
						$siteMenuLinkCountWidget.html(null);
						$siteMenuLinkCountWidget.hide();
					}
				}
			}
			else {
				console.error(`${NS}::Error`, `The ${key} value does not exist in the response`);
			}
		};

		$.ajax({
			type: 'GET',
			url: this.reportApi,
			dataType: 'json',
			success: (response) => {
				if(!_.isNil(response)) {
					setSiteMenuLinkCountWidgetValue(response, 'UnreadNotificationCount');
					setSiteMenuLinkCountWidgetValue(response, 'FavoriteCount');
				}
			},
			error: () => {
				console.error(`${NS}::Error`, 'Could not retrieve the count values…');
			}
		});
	}
}
